import React from 'react'

export default class CommentActiveIcon extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
        <g fill="none" fillRule="evenodd">
          <g fillRule="nonzero">
            <path
              fill="#6696C7"
              d="M20 17.087V21l-5.87-3.913H5.846c-1.337 0-1.822-.14-2.311-.4A2.726 2.726 0 0 1 2.4 15.551c-.262-.489-.401-.974-.401-2.31V6.845c0-1.337.14-1.822.4-2.311A2.726 2.726 0 0 1 3.536 3.4C4.024 3.139 4.509 3 5.845 3h10.31c1.336 0 1.821.14 2.31.4.49.262.873.646 1.134 1.135.262.489.401.974.401 2.31v10.242z"
            />
            <path fill="#FFF" d="M5.6 8.4H11v1H5.6zM5.6 11.1h10.8v1H5.6z" />
          </g>
        </g>
      </svg>
    )
  }
}
